// Client Reviews: the routes and the sidebar rows of `wealth.onboarding.client-reviews` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.onboarding.client-reviews',
    routes: [
        {
            frontend: 'desk',
            path: 'client-reviews',
            lazy: () => import('@/pages/desk/client-reviews/page'),
        },
        {
            frontend: 'desk',
            path: 'client-reviews/:clientId',
            lazy: () => import('@/pages/desk/client-reviews/client/page'),
        },
    ],
    nav: [
        // Superseded by the fact-find register above, and retired with it: the
        // row and its route are gone for every persona.
        {
            frontend: 'desk',
            key: 'client-reviews',
            label: 'Fact Find',
            href: '/desk/client-reviews',
            icon: 'ClipboardCheck',
            group: 'advice-suitability',
            order: 2150,
            hidden: true,
        },
    ],
});
